import React, {useState} from "react";
import {Popconfirm, Button} from "antd";
import {CustomButton} from "../../../../_defaultComponents/CustomButton/CustomButton";
import {CheckOutlined} from "@ant-design/icons";

const OnboardingStatusPopConfirm = ({onConfirm, row}) => {
    const [isApproved, setIsApproved] = useState(row.onboardingStatus === "approved");

    const handleConfirm = () => {
        onConfirm();
        setIsApproved(true);
    };

    return (
        <Popconfirm
            title="Aktifleştirmek istediğinize emin misiniz?"
            description="Onboarding statüsünü aktifleştirmek istediğinize emin misiniz?"
            onConfirm={handleConfirm}
            okText="Evet"
            cancelText="Hayır"
        >
            <CustomButton
                type="primary"
                data-testid="subCompanyOnboardingButton"
                icon={<CheckOutlined />}
            >
                Onboarding Durumunu Aktifleştir
            </CustomButton>
        </Popconfirm>
    );
};

export default OnboardingStatusPopConfirm;
